<template>
  <div id="messages-block">
    <h1 id="messages-block-header">Messages</h1>
    <b-table
      striped
      hover
      :items="items"
      :fields="fields"
      :id="tableId"
      show-empty
      :sticky-header="true"
      :no-sort-reset="true"
      :busy="isBusy"
    >
      <template #table-busy>
        <slot name="table-busy">
          <raft-busy busy-text="Loading..." />
        </slot>
      </template>

      <template #empty>
        <slot name="empty">
          <div class="empty-text">There are currently no messages to list.</div>
        </slot>
      </template>

      <template #cell(subject)="data">
        <div>
          <a
            :href="'/raft/message-center/message/' + data.item.id + '/view'"
            class="message-view-link"
            >{{ data.item.subject }}</a
          >
        </div>
      </template>
    </b-table>
    <a :href="viewInboxLink">View Entire Inbox</a>
  </div>
</template>

<script>
import { useMessaging } from "@/composables/useMessaging";
import { useDrupalSettings } from "@/composables/useDrupalSettings";
import RaftBusy from "../RaftBusy.vue";

const { config } = useDrupalSettings();

require("../../css/FixTableColumn.css");
require("../../css/B3BaseTable.css");

export default {
  name: "UserInboxBlock",
  components: {
    RaftBusy,
  },
  data() {
    return {
      items: [],
      isBusy: false,
      tableId: "message-block-table",
      fetchedMessages: [],
      fields: [
        {
          key: "sent_timestamp",
          label: "Date",
        },
        {
          key: "subject",
          label: "Subject",
          custom_slot: "subject-message",
        },
      ],
    };
  },
  setup() {
    const {
      setUserInboxQueries,
      fetchMessages,
      setBaseMessageFilters,
      dateSentFormatter,
    } = useMessaging();
    return {
      setUserInboxQueries,
      fetchMessages,
      setBaseMessageFilters,
      dateSentFormatter,
    };
  },
  async created() {
    this.toggleBusy();
    // 4 is the max number to show in UserInboxBlock
    this.setBaseMessageFilters(4);
    this.setUserInboxQueries(config.currentUser);
    const response = await this.fetchMessages();
    if (response) {
      this.fetchedMessages = response?.deserialized || [];
      this.parseMessages();
    }
    this.toggleBusy();
  },
  methods: {
    toggleBusy() {
      this.isBusy = !this.isBusy;
    },
    parseMessages() {
      this.fetchedMessages.forEach((message) => {
        this.items.push({
          sent_timestamp: this.dateSentFormatter(message.sent_timestamp),
          subject: message.subject,
          id: message.id,
        });
      });
    },
  },
  computed: {
    viewInboxLink() {
      if (config.isB4 && config.currentUser) {
        return `user/${config.currentUser}/message-center/inbox`;
      }
      return "raft/my_account/messaging";
    },
  },
};
</script>

<style scoped>
#messages-block-header {
  margin: 0;
  padding: 0 0 0.25em 0;
  font-size: var(--font-size-75);
}
</style>
